import React, { Component } from 'react';
import ContentEditable from 'react-contenteditable';
import styles from './styles.scss';
import classnames from 'classnames';

export default class InlineInput extends Component {
  constructor(props) {
    super(props);
    this.contentEditable = React.createRef();
  }

  componentDidMount() {
    if (this.props.innerRef) {
      this.props.innerRef(this.contentEditable.current);
    }
  }

  onChange = e => {
    let { value } = e.target;
    value = value.replace(/<[^>]+>/g, '');

    const txt = document.createElement('textarea');
    txt.innerHTML = value;

    this.props.onChange(txt.value);
  };

  handleReturn = e => {
    if (e.keyCode === 13) {
      e.target.blur();
      setTimeout(() => {
        if (this.props.onReturn) {
          this.props.onReturn();
        }
      });
    }
  };

  render() {
    return !this.props.disabled ? (
      <div
        className={classnames(styles.wrapper, {
          [styles.staticLine]: this.props.staticLine
        })}>
        <ContentEditable
          innerRef={this.contentEditable}
          html={this.props.value || ' '} // innerHTML of the editable div
          onChange={this.onChange} // handle innerHTML change
          onKeyDown={this.handleReturn}
          onBlur={this.props.onBlur}
          spellCheck={false}
          tagName="div"
        />
      </div>
    ) : (
      this.props.value
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/util/inlineInput/index.js